module.exports = __webpack_public_path__ + "img/privatefirst.03bab54a.png";